import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Config } from 'protractor';
import { firstValueFrom } from 'rxjs';

@Injectable()
export class HttpService {
    private basepath: string;
    constructor(private http: HttpClient) {
    }

    Get<T>(uri: string) {
        return this.http.get<T>(uri);
  }

  async AsyncGet<T>(uri: string) {
    return firstValueFrom(this.http.get<T>(uri));
  }

    Post<T, T1>(uri: string, reqData: T) {
        return this.http.post<T1>(uri, reqData);
  }

  async AsyncPost<T, T1>(uri: string, reqData: T) {
    return firstValueFrom(this.http.post<T1>(uri, reqData));
  }
  
    PostWithOption<T, T1, option>(uri: string, reqData: T, option: option) {
        return this.http.post<HttpResponse<Config>>(uri, reqData, option);
    }

    Put<T, T1>(uri: string, reqData: T) {
        return this.http.put<T1>(uri, reqData);
    }

    Delete<T>(uri: string) {
        return this.http.delete<T>(uri);
    }
}
